module.exports = __webpack_public_path__ + "img/thesis_nano.dabae2e3.jpg";